import { useTranslation } from 'react-i18next';

export function FeatureFlaggedTab() {
  const { t } = useTranslation('offers');

  return (
    <div
      className="flex min-h-[280px] items-center justify-center px-6 py-10 text-center"
      data-testid="feature-flagged-tab"
    >
      <p className="text-sm text-muted-foreground">{t('workspace.tabPlaceholder')}</p>
    </div>
  );
}
